<!-- props meanings : 

tPos = top position for tooltip  
bPos = bottom position for tooltip  
lPos = left position for tooltip  
rPos = right position for tooltip 


type =  {
         "help" = yellow color, light icon
         "info" = blue color , light icon
         "info2" = yellow color , light icon
         "success" = green color , check icon
         "warning" = yellow color , ! icon
         "danger" = red color , ! icon
        }

        minWidth :
        you can use number to determines tooltip min width 

        maxWidth :
        you can use number to determines tooltip max width 
      -->
      
<!-- you can use the component like these
  
        <Help
          classIcon="mb-1 ms-1"
          maxWidth="400"
          minWidth="400"
          type="help"
          message="test text"
          bPos
          /> 

      OR 

        <Help
          classIcon="mb-1 ms-1"
          maxWidth="400"
          minWidth="400"
          type="help"
          message="<b>test text</b>"
          bPos
       /> -->

<!-- if you want use the component in simplest way  -->
    <!-- <Help
          message="test text"
       /> -->

<template>
  <v-tooltip
    :max-width="maxWidth"
    :min-width="minWidth"
    :top="tPos"
    :right="rPos"
    :bottom="bPos"
    :left="lPos"
    :color="desType.color"
  >
    <template v-slot:activator="{ on, attrs }">
        <v-hover v-slot="{ hover }">
          <v-icon
            v-bind="attrs"
            v-on="on"
            :color="hover ? desType.hColor : desType.color"
            :class="classIcon"
            :small="small"
            :x-small="xSmall"
            dark
            v-html="information ? 'mdi-information-outline' : desType.icone"
          />
        </v-hover>
    </template>

    <span>
      <span v-if="Boolean(message)" style="display: block !important;" v-html="message" />
      <slot name="message" />
    </span>
  </v-tooltip>
</template>

<script>
  export default {
    install (Vue) {
      Vue.component('Help', this)
    },

    props: {
      message: {
        type: String,
        default: null,
      }, //this prop is message of tooltip 
      type: {
        type: String,
        default: 'help'
      }, //this prop is type of decription 
      classIcon: {
        type: String,
        default: null
      },
      tPos: {
        type: Boolean,
        default: false
      }, //this prop is position of message 
      rPos: {
        type: Boolean,
        default: false
      }, //this prop is position of message
      bPos: {
        type: Boolean,
        default: true
      }, //this prop is position of message
      lPos: {
        type: Boolean,
        default: false
      }, //this prop is position of message
      small: {
        type: Boolean,
        default: false
      },
      "x-small": {
        type: Boolean,
        default: false
      },
      information: {
        type: Boolean,
        default: false
      },
      minWidth: {
        type: String,
        default: "200",
      },
      maxWidth: {
        type: String,
        default: "200",
      },
     
    },

    data() {
      return { 
        help: {
          icone: "mdi-help-circle-outline",
          hColor: "#0082D9",
          color: "primary"
        },
        info: {
          // icone: "mdi-information-variant",
          icone: "mdi-lightbulb-on-outline",
          hColor: "#0082D9",
          color: "primary"
        },
        info2: {
          icone: "mdi-lightbulb-on-outline",
          hColor: "#D0A000",
          color: "warning"
        },
        // information: {
        //   icone: "mdi-information-outline",
        //   hColor: "#D0A000",
        //   color: "warning"
        // },
        success: {
          icone: "mdi-check-circle-outline",
          hColor: "#25A252",
          color: "success"
        },
        warning: {
          icone: "mdi-alert-outline",
          hColor: "#D0A000",
          color: "warning"
        },
        danger: {
          icone: "mdi-alert-octagon-outline",
          hColor: "#CB352E",
          color: "danger"
        }
      }
    },
    computed: {
      desType() {
        if(this.type === "help") {
          return this.help
        } else if(this.type === "info") {
          return this.info
        } else if(this.type === "info2") {
          return this.info2
        } else if(this.type === "success") {
          return this.success
        } else if(this.type === "warning") {
          return this.warning
        } else if(this.type === "danger") {
          return this.danger
        }
      }
    }
  }
</script>
<style scoped>
.pointer {
  cursor: pointer !important;
}
</style>